// import { isMobile } from "./isMobile";

jQuery(window).on("load scroll", function () {
  if ($(".contact-hide").length) {
    var location = $(".contact-hide").offset().top;
    var itemfixed = $(this).scrollTop();
    var op = $(window).height() / 2;

    if (itemfixed >= location - op + 500) {
      $(".section-fixed-left").removeClass("is-show").addClass("is-hide");
    } else {
      $(".section-fixed-left").removeClass("is-hide").addClass("is-show");
    }
  }
});
